import { merge } from "lodash"

import { isPhoneRefusal } from "./submitRefusal"

export const DefaultState = {
  currentStep: 1,
  furthestStepReached: 1,
  furthestJourneyStepReached: 0,
  contractDetailsSeen: false,
  marinaTermsAccepted: false,
  dockwaTermsAccepted: false,
  declined: false,
  expired: false,
  docusealFormSubmitted: false,
  submitFailure: null,
  paymentMethod: "",
  paymentMethods: [],
  paymentMethodKind: "",
  paymentType: "",
  paymentCheck: null,
  paymentMethodError: null,
  signature: "",
  additionalInformation: {},
  additionalInformationFiles: {},
  requiredInformation: {
    phone: "",
    insurance: {
      companyName: "",
      policyNumber: "",
      document: false,
      documentError: null,
      documentValidating: false,
      replacingDocument: false,
      expirationDate: null,
    },
    registration: {
      registrationNumber: "",
      document: false,
      documentError: null,
      documentValidating: false,
      replacingDocument: false,
      expirationDate: null,
    },
  },
}

const signContractWizardReducer = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_STEP":
      return {
        ...state,
        currentStep: action.payload,
        furthestStepReached: Math.max(
          state.furthestStepReached,
          action.payload
        ),
      }
    case "GO_TO_NEXT_STEP": {
      const currentStep = state.currentStep + 1
      return {
        ...state,
        currentStep,
        furthestStepReached: Math.max(state.furthestStepReached, currentStep),
      }
    }
    case "GO_TO_PREVIOUS_STEP": {
      const currentStep = state.currentStep - 1
      return {
        ...state,
        currentStep,
        furthestStepReached: Math.max(state.furthestStepReached, currentStep),
      }
    }
    case "CONTRACT_DETAILS_SEEN":
      return { ...state, contractDetailsSeen: true }
    case "PAYMENT_METHOD_SELECTED": {
      let paymentType = ""

      if (action.payload === "manual") {
        paymentType = "manual"
      } else if (action.payload) {
        paymentType = "credit"
      }

      return {
        ...state,
        paymentMethod: action.payload,
        paymentType,
        paymentCheck: null,
        paymentMethodError: null,
        submitFailure: null,
      }
    }
    case "PAYMENT_METHOD_ADDED":
      return merge(
        {},
        state,
        {
          paymentMethods: [...state.paymentMethods, action.payload],
        },
        {
          paymentMethod: action.payload.stripePaymentMethodId,
          paymentType: "credit",
          paymentCheck: null,
          paymentMethodError: null,
          submitFailure: null,
        }
      )
    case "PAYMENT_METHOD_KIND_SELECTED": {
      const isManual = action.payload === "manual"

      return {
        ...state,
        paymentMethodKind: action.payload,
        paymentMethod: isManual ? "manual" : "",
        paymentType: isManual ? "manual" : "",
        paymentCheck: null,
        paymentMethodError: null,
        submitFailure: null,
      }
    }
    case "PAYMENT_METHOD_CHECKED":
      return { ...state, paymentCheck: action.payload }
    case "PAYMENT_METHOD_REFUSED":
      return { ...state, paymentMethodError: action.payload }
    case "REQUIRED_INFORMATION_CHANGED": {
      const next = merge({}, state, { requiredInformation: action.payload })
      return "phone" in action.payload && isPhoneRefusal(state.submitFailure)
        ? { ...next, submitFailure: null }
        : next
    }
    case "ADDITIONAL_INFORMATION_CHANGED":
      return merge({}, state, {
        additionalInformation: action.payload,
      })
    case "ADDITIONAL_INFORMATION_FILE_ATTACHED": {
      const { id, signedId, name, size } = action.payload
      return {
        ...state,
        additionalInformation: {
          ...state.additionalInformation,
          [id]: signedId,
        },
        additionalInformationFiles: {
          ...state.additionalInformationFiles,
          [id]: { name, size },
        },
      }
    }
    case "ADDITIONAL_INFORMATION_FILE_REMOVED": {
      const { [action.payload]: _removed, ...files } =
        state.additionalInformationFiles
      return {
        ...state,
        additionalInformation: {
          ...state.additionalInformation,
          [action.payload]: "",
        },
        additionalInformationFiles: files,
      }
    }
    case "SIGNATURE_UPDATED":
      return { ...state, signature: action.payload }
    case "MARINA_TERMS_UPDATED":
      return { ...state, marinaTermsAccepted: action.payload }
    case "DOCKWA_TERMS_UPDATED":
      return { ...state, dockwaTermsAccepted: action.payload }
    case "CONTRACT_DECLINED":
      return { ...state, declined: true }
    case "CONTRACT_EXPIRED":
      return { ...state, expired: true }
    case "DOCUSEAL_FORM_SUBMITTED":
      return { ...state, docusealFormSubmitted: true, submitFailure: null }
    case "DOCUSEAL_FORM_RESET":
      return {
        ...state,
        docusealFormSubmitted: false,
        docusealFormCompleted: false,
      }
    case "SUBMIT_FAILED":
      return { ...state, submitFailure: action.payload }
    case "SUBMIT_FAILURE_CLEARED":
      return { ...state, submitFailure: null }
    case "STEP_REACHED":
      return {
        ...state,
        furthestJourneyStepReached: Math.max(
          state.furthestJourneyStepReached,
          action.payload
        ),
      }
    default:
      return state
  }
}

export default signContractWizardReducer
